module.exports = __webpack_public_path__ + "static/anne-pitman-logo-horizontal-navy-2967bb3b4a1476e8642d2da4af58e92e.svg";